import script from "./privateStake.vue?vue&type=script&setup=true&lang=js"
export * from "./privateStake.vue?vue&type=script&setup=true&lang=js"

import "./privateStake.vue?vue&type=style&index=0&id=48a935c1&lang=scss"

const __exports__ = script;

export default __exports__